import script from "./content-decorate.vue?vue&type=script&setup=true&lang=js"
export * from "./content-decorate.vue?vue&type=script&setup=true&lang=js"

import "./content-decorate.vue?vue&type=style&index=0&id=2bae8465&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bae8465"]])

export default __exports__